import React from 'react';
import { Search, Filter, Calendar, FilterX } from 'lucide-react';

interface SignalFiltersProps {
    search: string;
    onSearchChange: (val: string) => void;
    priority: string;
    onPriorityChange: (val: string) => void;
    type: string;
    onTypeChange: (val: string) => void;
    onClearFilters: () => void;
    className?: string;
}

const SignalFilters: React.FC<SignalFiltersProps> = ({
    search,
    onSearchChange,
    priority,
    onPriorityChange,
    type,
    onTypeChange,
    onClearFilters,
    className = "flex flex-wrap items-center gap-4 mb-8"
}) => {
    return (
        <div className={className}>
            {/* Category Filter */}
            <div className="relative">
                <select
                    className="border border-gray-200 rounded-md py-2 pl-3 pr-4 text-sm focus:ring-indigo-500 focus:border-indigo-500 bg-white"
                    value={type}
                    onChange={(e) => onTypeChange(e.target.value)}
                >
                    <option value="">Category: All</option>
                    <option value="ar">Category: AR</option>
                    <option value="ap">Category: AP</option>
                    <option value="cash">Category: Cash</option>
                    <option value="margin">Category: Margin</option>
                    <option value="data">Category: Data</option>
                </select>

            </div>

            {/* Priority Filter */}
            <div className="relative">
                <select
                    className="border border-gray-200 rounded-md py-2 pl-3 pr-8 text-sm focus:ring-indigo-500 focus:border-indigo-500 bg-white"
                    value={priority}
                    onChange={(e) => onPriorityChange(e.target.value)}
                >
                    <option value="">Priority: All</option>
                    <option value="1">Priority: High</option>
                    <option value="2">Priority: Medium</option>
                    <option value="3">Priority: Low</option>
                </select>
            </div>

            {/* <div className="relative">
                <button className="flex items-center justify-between min-w-[120px] bg-white border border-gray-200 rounded-lg px-4 py-2 text-xs font-semibold text-gray-700 hover:border-gray-300 transition-all shadow-sm">
                    <span>Date: All</span>
                    <Calendar size={12} className="text-gray-400" />
                </button>
            </div> */}

            {/* Clear Filters */}
            <div className="relative">
                <button
                    onClick={onClearFilters}
                    className="flex items-center gap-1 text-sm font-medium text-gray-600 hover:text-gray-900 px-3 py-1.5 rounded-md hover:bg-gray-100 transition-colors"
                >
                    <FilterX className="h-4 w-4" />
                    <span>Clear filters</span>
                </button>
            </div>
        </div>
    );
};

export default SignalFilters;
